module.exports = __webpack_public_path__ + "img/docker.c6b9b6cf.png";